/**
 * Product sticky add to cart bar:
 * - Single button that triggers the original static add to cart button (no form, reuses all main logic)
 * - Syncs label/disabled from main button when bar becomes visible
 * - Observes main button loading state and main spinner; mirrors loading on sticky, adds .hidden to sticky spinner after success/error
 * - Hidden while the cart drawer is open (body.cart-drawer-open from cart-drawer.js)
 */
document.addEventListener("DOMContentLoaded", () => {
  const bars = document.querySelectorAll(".product-sticky-add-to-cart");

  const isCartDrawerOpen = () =>
    document.body.classList.contains("cart-drawer-open");

  const visibilityUpdaters = [];

  bars.forEach((bar) => {
    const sentinelId = bar.dataset.sentinelId;
    const mainSubmitButtonId = bar.dataset.mainSubmitButtonId;

    if (!bar || !sentinelId || !mainSubmitButtonId) return;

    const stickyButton = bar.querySelector("[data-sticky-add-to-cart]");
    const stickyButtonText = bar.querySelector("[data-sticky-button-text]");
    const stickySpinner = bar.querySelector(".loading__spinner");
    const sentinel = document.getElementById(sentinelId);
    const mainSubmitButton = document.getElementById(mainSubmitButtonId);

    let scrollWantsVisible = false;

    const setBarVisible = (visible) => {
      bar.classList.toggle("is-visible", visible);
      bar.setAttribute("aria-hidden", !visible);
      if (visible) {
        bar.removeAttribute("hidden");
      } else {
        bar.setAttribute("hidden", "");
      }
    };

    const applyVisibility = () => {
      const visible = scrollWantsVisible && !isCartDrawerOpen();
      setBarVisible(visible);
      if (visible) syncStickyFromMainButton();
    };

    const syncStickyFromMainButton = () => {
      if (!mainSubmitButton || !stickyButton || !stickyButtonText) return;
      const disabled = mainSubmitButton.hasAttribute("disabled");
      stickyButton.toggleAttribute("disabled", disabled);
      const mainText = mainSubmitButton
        .querySelector("span")
        ?.textContent?.trim();
      if (mainText) stickyButtonText.textContent = mainText;
    };

    const setStickyLoading = (loading) => {
      stickyButton.classList.toggle("loading", loading);
      if (stickySpinner) {
        stickySpinner.classList.toggle("hidden", !loading);
      }
    };

    if (stickyButton && mainSubmitButton) {
      stickyButton.addEventListener("click", (e) => {
        e.preventDefault();
        if (mainSubmitButton.hasAttribute("disabled")) return;
        setBarVisible(false);
        mainSubmitButton.click();
      });

      const mainSpinner = mainSubmitButton.querySelector(".loading__spinner");
      const observer = new MutationObserver(() => {
        const mainLoading = mainSubmitButton.classList.contains("loading");
        if (mainLoading) {
          setStickyLoading(true);
        } else {
          setStickyLoading(false);
          if (stickySpinner) stickySpinner.classList.add("hidden");
        }
      });

      observer.observe(mainSubmitButton, {
        attributes: true,
        attributeFilter: ["class"],
      });
      if (mainSpinner) {
        observer.observe(mainSpinner, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }

    if (sentinel) {
      const intersectionObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!entry) return;
          scrollWantsVisible = !entry.isIntersecting;
          applyVisibility();
        },
        { root: null, rootMargin: "0px", threshold: 0 },
      );
      intersectionObserver.observe(sentinel);
      visibilityUpdaters.push(applyVisibility);
    }
  });

  if (visibilityUpdaters.length > 0) {
    new MutationObserver(() => {
      visibilityUpdaters.forEach((fn) => fn());
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    visibilityUpdaters.forEach((fn) => fn());
  }
});
